// @ts-strict-ignore
import { InputBlock } from '@coast/schemas/index';
import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBButton } from '@shared/components/button';
import { MBAutosizeTextInput, MBTextInput } from '@shared/components/textInput';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { getTextInputSize, isInputBold } from './input/utils';
import { AnchoredSheetInputBlock } from './inputBottomSheet';

interface Props {
  block: InputBlock;
}

export function MBCardInputBlockText({ block }: Props) {
  const colors = useContext(ColorThemeContext);

  return (
    <AnchoredSheetInputBlock<string>
      block={block}
      renderInput={({ value, setValue, mode, onBlur }) => (
        <MBTextInput
          noBorder
          noPadding
          autoFocus={mode === 'CREATE' ? block.autoFocus : false}
          value={value}
          onChangeText={setValue}
          onBlur={onBlur}
          size={getTextInputSize(block.textStyle)}
          bold={isInputBold(block.textStyle)}
          placeholder={block.placeholder}
        />
      )}
      renderEditForm={({ onSave, setValue, value }) => {
        return (
          <View fill padding={2}>
            <MBAutosizeTextInput
              style={{ backgroundColor: colors.backgroundInactive, borderRadius: grid(1) }}
              onChangeText={setValue}
              value={value}
              placeholder={block.placeholder}
              autoFocus
              padding="normal"
            />
            <View paddingBottom={2} />
            <MBButton title={i18n('common.ok')} onPress={onSave} />
          </View>
        );
      }}
    />
  );
}
